<div class="min-h-screen flex">
  <app-sidebar class="w-60 md:w-64 lg:w-72 shrink-0"></app-sidebar>
  <div class="flex-1 flex flex-col">
    <app-header></app-header>
    <main class="flex-1 p-4 overflow-auto">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
